export const shouldSkipOffersQuery = false;
export const UNAUTHENTICATED_REDEMPTIONS_ENABLED = true;
